import { createFeatureSelector } from '@ngrx/store';
import { EventFullState, eventFullFeatureKey } from '@stores/event-full/event-full.reducer';

export const selectEventFull = createFeatureSelector<EventFullState>(eventFullFeatureKey);
